// Ca 2026-08-18: `avatar doctor` cảnh báo "Chỉ có python3 … Pack scripts thường ref
// 'python'" trên máy hoàn toàn bình thường, và `--fix` không đụng tới được (check gắn
// cứng `fixable: false`). Đo lại pack đang cài: KHÔNG còn chỗ nào gọi `python` trần —
// tiền đề của cảnh báo đã lỗi thời, nó chỉ còn là nhiễu.
//
// Thay vì đoán "pack thường ref python", ĐO đúng chỗ CLI biết chắc sẽ chạy: các
// `command` trong `.claude/settings.json` (hooks + statusLine). Đó là nơi thiếu binary
// `python` gây hỏng thật; script nằm sâu trong pack tự chọn interpreter của chúng.

/** Mọi chuỗi `command` trong settings (hooks lồng nhiều tầng + statusLine). */
function collectCommands(node: unknown, out: string[]): void {
  if (Array.isArray(node)) {
    for (const item of node) collectCommands(item, out);
    return;
  }
  if (!node || typeof node !== "object") return;
  for (const [key, value] of Object.entries(node as Record<string, unknown>)) {
    if (key === "command" && typeof value === "string") out.push(value);
    else collectCommands(value, out);
  }
}

/**
 * Có `command` nào gọi `python` TRẦN (không phải `python3`, `python3.13`, `pythonX`)?
 *
 * JSON hỏng/rỗng ⇒ `false`: không bịa ra cảnh báo từ dữ liệu không đọc được. Ca "settings
 * hỏng" đã có check riêng của doctor lo.
 */
export function settingsReferencesBarePython(settingsRaw: string | null | undefined): boolean {
  if (!settingsRaw) return false;
  let parsed: unknown;
  try {
    parsed = JSON.parse(settingsRaw);
  } catch {
    return false;
  }
  const commands: string[] = [];
  collectCommands(parsed, commands);
  // `\bpython\b` một mình vẫn khớp "python3" ở nhiều engine vì ranh giới nằm giữa "n" và
  // "3"; phải chặn tường minh mọi hậu tố chữ/số/dấu chấm.
  return commands.some((c) => /(^|[\s"'`=/])python(?![\w.])/.test(c));
}
